// extracted by mini-css-extract-plugin
module.exports = {"noResult":"styles_noResult__1Kdkn","firstTitle":"styles_firstTitle__1ulMd","secondTitle":"styles_secondTitle__BozFv","clientNoResult":"styles_clientNoResult__1q2j5"};